import { axiosRetry } from '@/plugins/axios';

const base = '/venues';

export function get(slug) {
    return axiosRetry.get(`${base}/${slug}`, {
        timeout: 12000,
        'axios-retry': {
            retryCondition: err =>
                err.response ? err.response.status !== 404 : true
        }
    });
}
